/**
 * The cards a family keeps with us, as the server lists them.
 */
export interface SavedCard {
  brand: string
  expires: string
  id: string
  is_default: boolean
  last_four: string
}

/** Chosen in place of a saved card: pay with one not saved yet. */
export const NEW_CARD = 'new'

/** Make this the card every later lesson is charged to. */
export async function chargeLessonsTo(cardId: string): Promise<SavedCard[]> {
  const { data } = await window.axios.post(`/student/settings/cards/${cardId}/default`)

  return data.cards
}

export async function listCards(): Promise<SavedCard[]> {
  const { data } = await window.axios.get('/student/settings/cards')

  return data.cards
}
